import { Component, EventEmitter, Input, OnChanges, Output, SimpleChange } from '@angular/core';
import { UserDataToCheckPassword, UserPasswordAndToken } from '../../models/user';
import { ResetPasswordComponent } from '../user/reset-password/reset-password.component';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-password-strength-bar',
  templateUrl: './password-strength-bar.component.html',
  styleUrls: ['./password-strength-bar.component.scss']
})
export class PasswordStrengthBarComponent implements OnChanges {
  /**
   * Out strength
   */
  @Output() strengthChanged: EventEmitter<number> = new EventEmitter<number>();

  /**
   * User to check the password
   */
  @Input() userToCheck!: UserDataToCheckPassword;
  /**
   * Label to show in the top of the bar
   */
  @Input() barLabel!: string;
  /**
   * Variable to know if there are info about the user or is only the password
   */
  @Input() isForgotPassword = false;
  /**
   * password To Check
   */
  @Input() passwordToCheck!: string;
  /**
   * token
   */
  @Input() token!: string;

  /**
   * Possible label
   */
  style = [
    { label: 'PasswordStrengthBarComponent.veryWeak', color: '#F00' },
    { label: 'PasswordStrengthBarComponent.weak', color: '#F90' },
    { label: 'PasswordStrengthBarComponent.normal', color: '#FF0' },
    { label: 'PasswordStrengthBarComponent.strong', color: '#9F0' },
    { label: 'PasswordStrengthBarComponent.veryStrong', color: '#0F0' }
  ];

  /**
   * Can call method
   */
  canCallMethod = false;
  /**
   * Label selected
   */
  strengthValue = -1;

  /**
   * Base color
   *
   * @private
   */
  baseColor = '#C4C4C4';

  constructor(private userService: UserService, private resetPasswordComponent: ResetPasswordComponent) {}

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    if (!this.isForgotPassword && !changes.userToCheck) {
      return;
    }
    if (this.isForgotPassword && !changes.passwordToCheck) {
      return;
    }
    const password = changes.userToCheck ? changes.userToCheck.currentValue : changes.passwordToCheck.currentValue;
    if (!password) {
      return;
    }
    const observable = this.isForgotPassword
      ? this.userService.getPasswordScoreWithToken(new UserPasswordAndToken(this.passwordToCheck, this.token))
      : this.userService.getPasswordScore(this.userToCheck);

    this.canCallMethod =
      (!this.isForgotPassword && this.userToCheck.password !== '') ||
      (this.isForgotPassword && this.passwordToCheck !== '');

    if (this.canCallMethod) {
      observable.subscribe(
        (score) => {
          this.strengthValue = score.score;
          this.strengthChanged.emit(this.strengthValue);
        },
        (_) => {
          this.resetPasswordComponent.validToken = false;
        }
      );
    } else {
      this.strengthValue = -1;
    }
  }
}
